// Perfil do cliente enviado no consentimento (contrato interno da API de crédito).

export type PixKeyType = 'NaturalRegistrationNumber' | 'Phone' | 'Email' | 'Random';

export const PIX_KEY_TYPE_LABELS: Record<PixKeyType, string> = {
  NaturalRegistrationNumber: 'CPF',
  Phone: 'Celular',
  Email: 'E-mail',
  Random: 'Chave aleatória',
};

/** Valores de estado civil aceitos pela UY3 (NaturalPerson.civilStatus). */
export type CivilStatus = 'Married' | 'Widowed' | 'Separated' | 'Divorced' | 'Single';

export const CIVIL_STATUS_OPTIONS: ReadonlyArray<{ value: CivilStatus; label: string }> = [
  { value: 'Single', label: 'Solteiro(a)' },
  { value: 'Married', label: 'Casado(a)' },
  { value: 'Divorced', label: 'Divorciado(a)' },
  { value: 'Separated', label: 'Separado(a)' },
  { value: 'Widowed', label: 'Viúvo(a)' },
];

export interface CustomerAddressInput {
  addressName: string;
  zipCode: string;
  district: string;
  city: string;
  uf: string;
  number?: string;
  complement?: string;
}

export interface PaymentAccountInput {
  pixKeyType: PixKeyType;
  pixKey: string;
}

export interface CustomerProfileInput {
  name: string;
  birthDate: string;
  phone: string;
  email: string;
  civilStatus: CivilStatus;
  nationality: string;
  occupation: string;
  address: CustomerAddressInput;
  paymentAccount: PaymentAccountInput;
}

export interface CustomerProfileForm {
  name: string;
  /**
   * Data de nascimento no formato dd/mm/aaaa. Vem preenchida de `GET /v1/customer-profile`
   * (claim `dadosConsumidor`), mas o campo continua editável: a claim é opcional e a data é
   * `DateTime?` no portal, então pode chegar vazia.
   */
  birthDate: string;
  phone: string;
  email: string;
  civilStatus: CivilStatus | '';
  /** Nacionalidade do catálogo fixo. */
  nationality: string;
  /** Profissão: uma do catálogo (`OCCUPATION_OPTIONS`) ou o texto digitado quando a pessoa escolhe "Outra". */
  occupation: string;
  zipCode: string;
  addressName: string;
  number: string;
  complement: string;
  district: string;
  city: string;
  uf: string;
  pixKeyType: PixKeyType;
  pixKey: string;
}

export function emptyCustomerProfileForm(): CustomerProfileForm {
  return {
    name: '',
    birthDate: '',
    phone: '',
    email: '',
    civilStatus: '',
    nationality: 'Brasileira',
    occupation: '',
    zipCode: '',
    addressName: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    uf: '',
    pixKeyType: 'NaturalRegistrationNumber',
    pixKey: '',
  };
}
